(function() {
    angular.module("app").controller("RawReportModalController", RawReportModalController)

    RawReportModalController.$inject = [
        "$rootScope",
        "$scope",
        "$sce",
        "$uibModalInstance",
        "rawReport"
    ]

    function RawReportModalController(
        $rootScope,
        $scope,
        $sce,
        $uibModalInstance,
        rawReport
    ){
        "use strict"

        $scope.close = function() {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.rawReport = JSON.stringify(rawReport, undefined, 4)

    }
})()
